import React, { useEffect, useState } from "react";
import backgroundImage from "../assets/header-background.jpg";
import wordmark from "../assets/wordMark.png";
import logoMark from "../assets/logoMark.png";
import logoMarkWhite from "../assets/logoMarkWhite.png";
import downArrow from "../assets/DownArrow.png";
import sold from "../assets/sold.png";
import signboard from "../assets/signboardimage.jpg";
import star from "../assets/star.svg";
import rect1 from "../assets/rect1.png";
import rect2 from "../assets/rect2.png";
import rect3 from "../assets/rect3.png";
import rect4 from "../assets/rect4.png";
import rect5 from "../assets/rect5.png";
import rect6 from "../assets/rect6.png";
import rect9 from "../assets/rect9.png";
import rect10 from "../assets/rect10.png";
import AddressInput from "../components/AddressInput";
import Popup from "../components/Popup";
import juliettStreet from "../assets/48-juliett-street-enmore.jpg";
import charlesStreet from "../assets/50a-charles-street-leichhardt.jpg";
import albanyRoad from "../assets/144-albany-road-stanmore.jpg";
import addisonRoad from "../assets/216-addison-road-marrickville.jpg";
import arrowRight from "../assets/arrowRight.svg";
import arrowLeft from "../assets/arrowLeft.svg";
import Carousel from "../components/Carousel";
import ContactForm from "../components/ContactForm";
import {
  handleButtonClickedEvent,
  handleFormSubmissionEvent,
} from "../util/events";
import { useParams } from "react-router-dom";

/* global fbq */

const properties = [
  {
    address: (
      <>
        <p>48 JULIETT ST</p>
        <p>ENMORE</p>
      </>
    ),
    image: juliettStreet,
  },
  {
    address: (
      <>
        <p>50A CHARLES ST</p>
        <p>LEICHHARDT</p>
      </>
    ),
    image: charlesStreet,
  },
  {
    address: (
      <>
        <p>144 ALBANY RD</p>
        <p>STANMORE</p>
      </>
    ),
    image: albanyRoad,
  },
  {
    address: (
      <>
        <p>216 ADDISON RD</p>
        <p>MARRICKVILLE</p>
      </>
    ),
    image: addisonRoad,
  },
];

const capitalize = (str) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

const LandingPage = () => {
  const { agent: rawAgentParam } = useParams();
  const [agents, setAgents] = useState([]);
  const [agentsLoading, setAgentsLoading] = useState(true);

  const normalize = (str = "") => decodeURIComponent(str).toLowerCase().trim();
  const agentSlug = normalize(rawAgentParam);
  const agent = agentSlug
    ? agents.find(
        (agent) => agent.slug?.toLowerCase() === agentSlug?.toLowerCase()
      )
    : null;

  const [address, setAddress] = useState();
  const [popupVisible, setPopupVisible] = useState(false);
  const [thankYouVisible, setThankYouVisible] = useState(false);
  const [errorVisible, setErrorVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [submitLoading, setSubmitLoading] = useState(false);

  const handleButtonClicked = (eventName = "GetYourReportButtonClicked") => {
    handleButtonClickedEvent(eventName, { agent: agent?.name ?? "" });
    setPopupVisible(true);
  };

  const closePopup = () => {
    setPopupVisible(false);
    setThankYouVisible(false);
  };

  const handleAddressSubmit = () => {
    handleButtonClicked("AddressContinueButtonClicked");
  };

  const handleSubmit = async (formData) => {
    setPopupVisible(true);
    setSubmitLoading(true);

    handleFormSubmissionEvent(formData, {
      agent: agent?.name ?? "",
      form_type: formData.subject ? "page" : "popup",
    });

    if (formData?.email?.includes("@hustle.agency")) {
      console.log("Test email, skipping report");
      if (typeof fbq === "function") {
        fbq("track", "Lead", {
          content_name: "Property Report Submission",
          agent: agent?.name ?? "Adrian William",
        });
      }
      setThankYouVisible(true);
      setAddress(null);
      setSubmitLoading(false);
    } else {
      try {
        const response = await fetch(
          "https://agent.adrianwilliam.com.au/scripts/send-report-email-with-pdf.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
            body: new URLSearchParams({
              agentWebsite:
                agent?.agentProfilePage ?? "https://adrianwilliam.com.au",
              agentFullName: agent?.fullName ?? "Adrian William",
              agentFirstName: agent?.name ? capitalize(agent.name) : "team",
              agentRole: agent?.role ?? "",
              agentEmail: agent?.email ?? "info@adrianwilliam.com.au",
              ...formData,
              address: formData.address.label,
              propertyId: formData.address.value,
            }),
          }
        );

        if (response.ok) {
          if (typeof fbq === "function") {
            fbq("track", "Lead", {
              content_name: "Property Report Submission",
              agent: agent?.name ?? "Adrian William",
            });
          }
          setThankYouVisible(true);
        } else {
          setErrorVisible(true);
        }
      } catch (error) {
        setErrorVisible(true);
      } finally {
        setAddress(null);
        setSubmitLoading(false);
      }
    }
  };

  const goNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === properties.length - 1 ? 0 : prevIndex + 1
    );
  };

  const goPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? properties.length - 1 : prevIndex - 1
    );
  };

  let stats = {
    propertiesSold: 429,
    buyersMet: "20,340",
    soldPropertyValue: "$570,831,375",
    agencyRanking: "#1/233",
    averageDaysOnMarket: "25",
  };
  if (agent) {
    stats = agent.stats;
  }

  useEffect(() => {
    const loadAgents = async () => {
      try {
        const response = await fetch("/agents.json");
        const data = await response.json();
        setAgents(data);
      } catch (error) {
        console.error("Error loading agents:", error);
        setAgents([]);
      } finally {
        setAgentsLoading(false);
      }
    };

    loadAgents();
  }, []);

  if (agentsLoading) {
    return (
      <div className="bg-lightGray text-gray-800 font-maison-neue w-full max-w-[100vw] h-screen flex items-center justify-center">
        <div className="loader"></div>
      </div>
    );
  }

  return (
    <div className="bg-lightGray text-gray-800 font-maison-neue w-full max-w-[100vw]">
      {/* Header Section */}
      <div className="h-auto lg:h-[90vh] w-full flex flex-col lg:flex-row lg:items-start">
        {/* Left side - Main Text */}
        <div
          className="px-5 lg:px-16 pt-9 lg:pt-14 pb-20 lg:pb-24 lg:h-full lg:flex-1 bg-cover bg-center text-white"
          style={{ backgroundImage: `url(${backgroundImage})` }}
        >
          <img
            src={agent ? wordmark : logoMarkWhite}
            alt="wordmark"
            className={agent ? "mb-20 w-36 lg:w-72" : "mb-20 w-16 lg:w-28"}
          />
          {agent ? (
            <>
              <p className="text-xl lg:text-4xl leading-normal font-nantes font-normal">
                The Market is always changing...
              </p>
              <h1 className="text-6xl lg:text-9xl font-maison-neue font-medium leading-tight capitalize">
                {agent.name}
              </h1>
            </>
          ) : (
            <>
              <p className="text-xl lg:text-4xl leading-normal font-nantes font-normal">
                The Market is always changing...
              </p>
              <img
                src={wordmark}
                alt="wordmark"
                className="w-80 lg:w-[668px] my-2 lg:my-4"
              />
            </>
          )}
          <p
            className={`${
              agent ? "text-xl" : "text-xl mb-7 lg:mb-14"
            } lg:text-4xl leading-tight font-nantes font-normal`}
          >
            knows what your place is worth.
          </p>
          <div className="hidden lg:block lg:w-10/12 lg:mt-14">
            <p className="mb-3 font-maison-neue font-normal text-xl leading-normal">
              Enter your address for a detailed property report
            </p>
            <AddressInput
              value={address}
              onChange={setAddress}
              handleSubmit={handleAddressSubmit}
              isTransparent
            />
          </div>
          {agent && (
            <div className="lg:hidden my-5">
              <AddressInput
                value={address}
                onChange={setAddress}
                handleSubmit={handleAddressSubmit}
              />
            </div>
          )}
          <div className="lg:mt-12 mb-1.5 lg:mb-3 flex flex-row gap-1.5">
            {Array.from({ length: 5 }).map((_, index) => (
              <img
                key={index}
                src={star}
                alt={"star" + index}
                className="w-5 h-5 lg:w-9 lg:h-9"
              />
            ))}
          </div>
          <p
            className={`text-sm lg:max-w-[520px] ${
              agent ? "lg:text-xl" : "text-base"
            } font-maison-neue font-normal leading-normal mb-2.5`}
          >
            “
            {agent?.reviewMessage ??
              "Adrian William are a team that stand out from the rest. They are forward thinking, knowledgable and creative, and their dedication is what stands out and truly makes a difference. Adrian William got in touch with us, opened us up to ideas and provided us with the best strategy to get the best Results!”"}
            ”
          </p>
          <p className="text-xs lg:text-lg uppercase leading-normal">
            {agent?.reviewName ?? "STEPHANIE, VENDOR"}
          </p>
        </div>

        {/* Below / Right side - Agent Profile */}
        <div
          className={
            "relative w-full lg:h-full lg:w-[30%] lg:max-w-[500px] lg:p-10 flex flex-col lg:justify-between bg-lightGray"
          }
        >
          <div>
            <button
              onClick={handleButtonClicked}
              className="hidden lg:inline-block w-full px-6 py-3 mb-8 bg-primary text-white text-xl"
            >
              GET YOUR REPORT
            </button>

            <div className="relative hidden lg:block">
              {agent?.image ? (
                <img src={agent.image} alt="Agent" className="w-full" />
              ) : (
                <div className="relative">
                  <Carousel
                    items={properties.map((property) => property?.image)}
                    currentIndex={currentIndex}
                    renderItem={(image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt="Property"
                        className="w-full overflow-hidden"
                      />
                    )}
                  />
                  <img
                    src={sold}
                    alt="Sold"
                    className="absolute top-10 -right-6 w-56 z-10 transform -rotate-6"
                  />
                </div>
              )}
            </div>
          </div>

          <div className="w-full px-5 lg:px-0 flex flex-col">
            <div className="w-full flex flex-row justify-between lg:block">
              <div className="z-10 flex-1 lg:hidden transform -translate-y-12">
                {agent?.image ? (
                  <img src={agent.image} alt="Agent" className="w-full" />
                ) : (
                  <Carousel
                    items={properties.map((property) => property?.image)}
                    currentIndex={currentIndex}
                    renderItem={(image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt="Property"
                        className="w-full"
                      />
                    )}
                  />
                )}
              </div>
              <div className="text-right font-maison-mono font-normal text-primary text-sm lg:text-xl leading-normal flex-1 lg:flex-none">
                {agent ? (
                  <div className="pt-5 lg:pt-0">
                    <p className="uppercase">{agent.fullName}</p>
                    <p className="uppercase">{agent.role}</p>
                    <a
                      href={"tel:" + agent.phoneNumber.replace(/\s+/g, "")}
                      className="underline cursor-pointer"
                    >
                      {agent.phoneNumber}
                    </a>
                    <div className="lg:hidden flex flex-row w-full justify-end my-6">
                      <img src={logoMark} alt="Logo" className="w-20" />
                    </div>
                  </div>
                ) : (
                  <div className="pt-5 lg:pt-0 flex flex-col lg:flex-row-reverse lg:w-full lg:justify-between lg:items-end">
                    <div className="flex-1">
                      {properties[currentIndex].address}
                    </div>
                    <div className="flex flex-row gap-5 lg:gap-10 justify-end mt-3">
                      <img
                        src={arrowLeft}
                        alt="Arrow Left"
                        className="w-7 cursor-pointer"
                        onClick={goPrev}
                      />
                      <img
                        src={arrowRight}
                        alt="Arrow Right"
                        className="w-7 cursor-pointer"
                        onClick={goNext}
                      />
                    </div>
                    <div className="lg:hidden flex flex-row w-full justify-end mb-8 mt-6">
                      <img src={sold} alt="Sold" className="w-24" />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {!agent && (
              <div className="lg:hidden transform -translate-y-8">
                <AddressInput
                  value={address}
                  onChange={setAddress}
                  handleSubmit={handleAddressSubmit}
                />
              </div>
            )}
          </div>
        </div>
      </div>

      {/* About Section */}
      <section className="relative px-5 py-12 lg:px-14 lg:py-20 bg-white flex items-start w-full">
        {/* Arrow icon positioned at the top-right */}
        <img
          src={downArrow}
          alt="Arrow Icon"
          style={{ width: 24 }}
          className="hidden lg:inline-block absolute top-11 right-11"
        />

        {/* Main Content */}
        <div className="flex-1 lg:flex-none lg:w-8/12">
          <p className="text-2xl lg:text-4xl text-left font-maison-neue font-normal text-primary leading-normal lg:leading-normal">
            {agent ? capitalize(agent.name) : "Adrian William"} is an{" "}
            experienced real estate {agent ? "agent" : "agency"} with{" "}
            {agent ? agent.pronoun : "its"} finger on the pulse of the market.
            With property prices constantly changing, your home's value has
            likely shifted in the last month. Enter your address, and{" "}
            {agent ? capitalize(agent.name) : "Adrian William"} will send you a
            detailed, up-to-date property report.
          </p>
          <button
            onClick={handleButtonClicked}
            className="w-full lg:w-auto lg:px-24 mt-7 py-3 lg:py-4 bg-primary text-white leading-normal font-maison-mono font-normal uppercase lg:text-xl"
          >
            GET YOUR REPORT
          </button>
        </div>

        {/* Logo positioned at the bottom-right */}
        <img
          src={logoMark}
          alt="Logo"
          style={{ width: 70 }}
          className="hidden lg:inline-block absolute bottom-4 right-4 lg:bottom-20 lg:right-14"
        />
      </section>

      {/* Statistics Section */}
      <section className="lg:relative px-5 pt-8 pb-7 lg:pb-20 lg:pt-16 bg-lightGray text-center text-primary flex flex-col items-center">
        {/* "SOLD" Image */}
        <div className="w-full">
          <img
            src={sold}
            alt="SOLD"
            className="w-48 lg:[240px] xl:w-[320px] 2xl:w-[400px] lg:absolute lg:top-16 lg:left-16 transform lg:-rotate-12"
          />
        </div>

        {/* Agency Report Date */}
        <p className="text-xs lg:text-xl lg:mb-4 font-maison-mono font-normal leading-normal uppercase mt-5 mb-1">
          {agent ? "Agent" : "Agency"} Report | Last 12 Months
        </p>

        {/* Statistics */}
        <div className="text-center text-2xl lg:text-5xl font-maison-neue font-medium leading-normal flex flex-col lg:gap-4">
          <p>
            {agent ? agent.stats.propertiesSold : stats.propertiesSold}{" "}
            <span className="font-nantes font-normal">properties sold.</span>
          </p>
          <p>
            {agent ? agent.stats.buyersMet : stats.buyersMet}{" "}
            <span className="font-nantes font-normal">buyers met.</span>
          </p>
          <p>
            {agent ? agent.stats.soldPropertyValue : stats.soldPropertyValue}{" "}
            <span className="font-nantes font-normal">
              in sold property value.
            </span>
          </p>
          <p>
            {agent ? agent.stats.agencyRanking : stats.agencyRanking}{" "}
            <span className="font-nantes font-normal">
              agency ranking in our marketplace.
            </span>
          </p>
          <p className="flex flex-col lg:gap-1">
            <span>
              {agent
                ? agent.stats.averageDaysOnMarket
                : stats.averageDaysOnMarket}{" "}
              <span className="font-nantes font-normal">
                average days on market*
              </span>
            </span>
            <span className="font-nantes font-normal text-xs lg:text-lg">
              *Market average: 38 days. Source:{" "}
              <a href="https://domain.com.au" className="underline">
                Domain.com.au
              </a>
            </span>
          </p>
        </div>

        {/* Button */}
        <button
          onClick={handleButtonClicked}
          className="font-maison-mono font-normal w-full lg:w-auto mt-8 lg:px-24 py-3 lg:py-4 bg-primary lg:text-xl leading-normal text-white"
        >
          GET YOUR REPORT
        </button>
      </section>

      {/* Listing Performance Section */}
      <section className="relative px-5 lg:px-0 pt-16 lg:pt-0 flex justify-center items-start bg-primary lg:h-[600px]">
        {/* Left Side - Property Image with Overlap */}
        <div className="hidden lg:flex lg:flex-row lg:justify-end transform translate-y-20 z-10 lg:flex-1">
          <img
            src={signboard}
            alt="Property"
            className="w-full max-w-[900px]"
          />
        </div>

        {/* Right Side - Text and Input */}
        <div className="text-white z-10 lg:flex-1 lg:h-full">
          <div className="lg:px-20 lg:h-full lg:flex lg:flex-col lg:justify-center">
            <h3 className="text-2xl leading-normal font-maison-neue font-regular mb-9 mr-9 lg:mr-0 lg:max-w-[500px]">
              Property prices fluctuate constantly due to changing interest
              rates, buyer demand, and local trends. Your home’s value has
              likely shifted in the past month. Enter your address for a
              detailed property report.
            </h3>
            <AddressInput
              value={address}
              onChange={setAddress}
              handleSubmit={handleAddressSubmit}
            />
          </div>
          <img
            src={signboard}
            alt="Property"
            className="lg:hidden transform translate-y-12"
          />
        </div>
      </section>

      {/* Detailed Statistics Section */}
      <section className="relative px-5 pt-20 pb-10 lg:pb-0 lg:pt-24 bg-lightGray flex flex-col lg:flex-row justify-center items-start lg:items-center">
        {/* Left Column - Report Text */}
        <div className="text-left mb-5 text-sm lg:text-xl uppercase font-maison-mono font-normal lg:flex-1 lg:mb-0 lg:flex lg:flex-col lg:items-end lg:border-r lg:border-r-black lg:py-20">
          <p className="lg:pr-28">
            AGENCY REPORT | 2024
            <br />
            SOURCE | DOMAIN.COM
          </p>
        </div>
        <div className="lg:flex-1">
          <div className="grid grid-cols-2 w-full font-maison-mono font-normal lg:px-28 lg:mb-16">
            <div className="lg:order-2 flex flex-col gap-0.5 col-span-2 lg:col-span-1 pb-7 lg:pb-0">
              <div
                className="text-white leading-normal pl-[8px] bg-cover bg-no-repeat flex flex-col justify-center text-sm lg:text-base w-[274px] h-[23px] lg:w-[313] lg:h-[27px]"
                style={{
                  backgroundImage: `url(${rect1})`,
                }}
              >
                ADRIAN WILLIAM AVERAGE
              </div>
              <div
                className="text-primary leading-normal pl-[9px] bg-cover bg-no-repeat flex flex-col justify-center text-sm lg:text-base w-[235px] h-[23px] lg:w-[269px] lg:h-[27px]"
                style={{
                  backgroundImage: `url(${rect2})`,
                }}
              >
                MARKET AVERAGE
              </div>
            </div>
            <p className="lg:order-1 hidden lg:block font-maison-neue-extended font-medium text-lg leading-tight text-primary pl-[18px] lg:pl-0 pb-16">
              LISTING
              <br />
              PERFORMANCE
            </p>
            <div className="lg:order-4 flex flex-col gap-0.5 overflow-hidden pt-1">
              <div
                className="text-white leading-normal pl-[7px] bg-cover bg-no-repeat text-sm lg:text-base flex flex-col justify-center ml-[2px] w-[228px] h-[22.5px] lg:w-[261px] lg:h-[26px]"
                style={{
                  backgroundImage: `url(${rect3})`,
                }}
              >
                2730
              </div>
              <div
                className="relative text-primary leading-normal pl-[7px] bg-cover bg-no-repeat text-sm lg:text-base flex flex-col justify-center ml-[2px] w-[139px] h-[23px] lg:w-[159] lg:h-[27px]"
                style={{
                  backgroundImage: `url(${rect4})`,
                }}
              >
                1865
              </div>
            </div>
            <p className="lg:order-3 font-nantes font-normal text-lg lg:text-2xl leading-normal text-primary pl-[18px] lg:pl-0 pb-8 lg:pb-11">
              <span className="font-maison-neue font-medium mr-1">2,730</span>{" "}
              number of
              <br />
              views
            </p>
            <div className="lg:order-6 flex flex-col gap-0.5 overflow-hidden pt-1">
              <div
                className="text-white font-normal leading-normal pl-1 bg-cover bg-no-repeat text-sm lg:text-base flex flex-col justify-center ml-[1px] w-[226px] h-[22.5px] lg:w-[259px] lg:h-[26px]"
                style={{
                  backgroundImage: `url(${rect5})`,
                }}
              >
                1636
              </div>
              <div
                className="relative text-primary font-normal leading-normal pl-[5px] bg-cover bg-no-repeat text-sm lg:text-base flex flex-col justify-center w-[133px] h-[23px] lg:w-[152px] lg:h-[27px]"
                style={{
                  backgroundImage: `url(${rect6})`,
                }}
              >
                1148
              </div>
            </div>
            <p className="lg:order-5 font-nantes font-normal text-lg lg:text-2xl leading-normal text-primary pl-[18px] lg:pl-0 pb-8 lg:pb-11">
              <span className="font-maison-neue font-medium mr-1">1,636</span>{" "}
              number of
              <br />
              engagements
            </p>
            <div className="lg:order-10 flex flex-col gap-0.5 overflow-hidden pt-1">
              <div
                className="text-white font-normal leading-normal pl-[9px] bg-cover bg-no-repeat text-sm lg:text-base flex flex-col justify-center"
                style={{
                  backgroundImage: `url(${rect9})`,
                  width: 240,
                  height: 29,
                }}
              >
                152
              </div>
              <div
                className="text-primary font-normal leading-normal pl-[9px] bg-cover bg-no-repeat text-sm lg:text-base flex flex-col justify-center"
                style={{
                  backgroundImage: `url(${rect10})`,
                  width: 114,
                  height: 28,
                }}
              >
                86
              </div>
            </div>
            <p className="lg:order-9 font-nantes font-normal text-lg lg:text-2xl leading-normal text-primary pl-[18px] lg:pl-0 pb-8 lg:pb-11">
              <span className="font-maison-neue font-medium mr-1">152</span>{" "}
              number of saves
              <br />
              and shares
            </p>
          </div>
        </div>
        <button
          onClick={handleButtonClicked}
          className="lg:hidden w-full mt-5 py-3 bg-primary text-white leading-normal font-normal uppercase"
        >
          GET YOUR REPORT
        </button>
      </section>

      {/* Contact Form Section */}
      <section className="px-5 pt-9 pb-12 lg:p-0 bg-white lg:flex lg:flex-row">
        <div className="lg:flex-1">
          <div className="lg:pt-60 lg:px-36">
            <h3 className="text-3xl lg:text-5xl font-nantes font-normal lg:leading-snug text-primary">
              The true value of your property awaits
            </h3>
            <p className="mt-4 lg:mt-3 lg:text-2xl font-maison-neue font-normal">
              Enter your details and we’ll be in touch.
            </p>
          </div>
        </div>
        <div className="lg:flex-1">
          <div className="mt-10 lg:mt-28 lg:mb-32 lg:pr-20">
            <ContactForm
              handleSubmit={handleSubmit}
              address={address}
              includeDetails
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="p-8 bg-lightGray text-white flex flex-col lg:flex-row-reverse items-center gap-7">
        <div className="hidden lg:block lg:flex-1"></div>
        <p className="text-primary font-maison-neue font-normal text-xs text-center lg:text-2xl">
          Want to see more? Visit the{" "}
          <a
            href="https://adrianwilliam.com.au"
            className="underline"
            onClick={() =>
              handleButtonClickedEvent("VisitWebsiteLinkPressed", {
                agent: agent?.name ?? "",
              })
            }
          >
            Adrian William website here
          </a>
          .
        </p>
        <div className="lg:flex-1 lg:flex lg:flex-row lg:justify-center lg:items-center">
          <img src={logoMark} alt="Logo" className="w-32" />
        </div>
      </footer>
      <Popup visible={popupVisible} onClose={closePopup}>
        {submitLoading && (
          <div className="flex flex-col justify-center items-center py-5">
            <div className="loader"></div>
          </div>
        )}
        {!submitLoading && (
          <>
            {thankYouVisible && (
              <div className="flex flex-col lg:items-start">
                <h3 className="text-3xl lg:text-6xl font-nantes font-normal leading-tight lg:leading-snug text-primary">
                  Thank you.
                </h3>
                <p className="mt-4 lg:text-2xl font-nantes font-normal">
                  You’ll receive a detailed property report in your inbox soon.
                </p>
                <a
                  href={
                    agent?.agentProfilePage
                      ? agent?.agentProfilePage
                      : "https://adrianwilliam.com.au"
                  }
                  className="w-full lg:w-auto font-maison-mono text-center font-normal lg:px-16 py-4 mt-5 lg:mt-10 bg-primary text-white"
                  onClick={() =>
                    handleButtonClickedEvent("VisitWebsiteButtonPressed", {
                      agent: agent?.name ?? "",
                    })
                  }
                >
                  VISIT OUR WEBSITE
                </a>
              </div>
            )}
            {errorVisible && (
              <div className="flex flex-col lg:items-start">
                <h3 className="text-3xl lg:text-6xl font-nantes font-normal leading-tight lg:leading-snug text-primary">
                  Sorry.
                </h3>
                <p className="mt-4 lg:text-2xl font-nantes font-normal">
                  There was an error submitting your details, please try again.
                </p>
                <button
                  onClick={() => setErrorVisible(false)}
                  className="w-full lg:w-auto font-maison-mono font-normal lg:px-16 py-4 mt-5 bg-primary text-white"
                >
                  TRY AGAIN
                </button>
              </div>
            )}
            {!thankYouVisible && !errorVisible && (
              <div className="flex flex-col">
                <h3 className="text-3xl lg:text-5xl font-nantes font-normal leading-tight lg:leading-snug text-primary">
                  {address
                    ? "Fetching your property value now."
                    : "The true value of your property awaits."}
                </h3>
                <p className="mt-2 lg:text-2xl font-maison-neue font-normal">
                  Enter your details and a member of our team will be in touch
                  shortly.
                </p>
                <div className="mt-7">
                  <ContactForm handleSubmit={handleSubmit} address={address} />
                </div>
              </div>
            )}
          </>
        )}
      </Popup>
    </div>
  );
};

export default LandingPage;
